import { CheckCircle2 } from "lucide-react";
import { Button } from "../components/Button";
import { useCart } from "../lib/cart";
import { navigateTo } from "../lib/navigation";

export function CheckoutSuccessPage() {
  const cart = useCart();

  return (
    <main className="page-shell success-page">
      <CheckCircle2 size={58} />
      <h1>Order request received</h1>
      <p>Thank you. Your bistro order or booking deposit is in motion.</p>
      <Button
        onClick={() => {
          cart.clear();
          navigateTo("/");
        }}
      >
        Back to home
      </Button>
    </main>
  );
}
